import React, { Component } from 'react';
export default class Header extends Component {
	render() {
		let resumeData = this.props.resumeData;
		return (<React.Fragment>{
			<section id = "about" >
				<div className = "row" >
					<div className = "three columns" >
						<img className = "profile-pic" src = "images/profilepic.jpg" alt/>
					</div>
					<div className = "nine columns main-col" >
						<h2> About Me </h2>
						<p>
							{resumeData.about_me_1} <br/> <br/>
							{resumeData.about_me_2} <br/> <br/>
							{resumeData.about_me_3} <br/> <br/>
							{resumeData.about_me_4} <br/> <br/>
							{resumeData.about_me_5}
						</p>
					<div className = "row" >
					<div className = "columns contact-details" >
						<h2 > Contact Details </h2>
						<p className = "address" >
							<span> {resumeData.name} </span> <br/>
							<span> {resumeData.address} </span> <br/>
							<span > {resumeData.email} </span>
						</p>
					</div>
					<div className = "columns download">
						<p>
							<a href = "andrew-chen-resume.pdf" className = "button" target="_blank">
								<i className = "fa fa-download"/> Download Resume
							</a>
						</p>
					</div>
					</div> {
						/* end row */
					}
					</div> {/* end .main-col */}
				</div>
			</section >
		} </React.Fragment>);
	}
}